import apiClient from '@/repositories/apiClient';
import { postLoginParam } from './usersRepository.param';

const getMyData = async () => {
  return await apiClient({
    method: 'get',
    url: '/user/me',
  });
}

const postLogin = async ({ email, password} : postLoginParam) => {
  return await apiClient({
    method: 'post',
    url: '/user/login',
    data: {
      email,
      password
    },
  });
};

// Triggers the backend's password-reset mail flow. The endpoint deliberately
// returns the same response shape regardless of whether the email exists, so
// the UI confirmation is shown unconditionally — never branch on this result
// to disclose account existence.
const postForgetPassword = async (email: string) => {
  return await apiClient({
    method: 'post',
    url: '/users/forget_password',
    data: { email },
  });
};

export {getMyData, postLogin, postForgetPassword};
